import { FC, useRef } from "react";
import { useParams } from "react-router-dom";
import { TabsProvider } from "../../../context/tabsContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useDkvCostImportsApi } from "../../../http/dkvCostImports/api";
import Header from "../../ui/Header";
import Tabs, { TabContent, TabsContents } from "../../ui/Tabs";
import DkvCostImports from "./DkvCostImport";

const TabsDkv: FC = () => {
  const i18n = useI18n();

  return (
    <>
      <Header title={i18n.t.common.importDkv} />
      <TabsProvider>
        <TabbedDkv />
      </TabsProvider>
    </>
  );
};

export default TabsDkv;

const TabbedDkv: FC = () => {
  const i18n = useI18n();
  const { id } = useParams<{ id: string }>();
  const aborter = useRef(new AbortController());
  const dkvImportsApi = useDkvCostImportsApi();

  const dataWithErrors = dkvImportsApi.useDkvCostImports({}, aborter.current.signal, id!, true);
  const hasError = !!dataWithErrors.data?.total;

  const tabs = [
    { title: i18n.t.common.all },
    { title: i18n.t.common.withErrors, hasError },
    { title: i18n.t.common.withoutErrors },
    { title: i18n.t.common.itemsNotExported },
    { title: i18n.t.common.itemsForced },
  ];

  const tabComponents: TabContent[] = [
    {
      body: <DkvCostImports />,
      withBorder: true,
    },
    {
      body: <DkvCostImports withErrors />,
      withBorder: true,
    },
    {
      body: <DkvCostImports withErrors={false} />,
      withBorder: true,
    },
    {
      body: <DkvCostImports notExported />,
      withBorder: true,
    },
    {
      body: <DkvCostImports forced />,
      withBorder: true,
    },
  ];

  return (
    <>
      <Tabs tabs={tabs} />
      <TabsContents contents={tabComponents} />
    </>
  );
};
